import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import { breakUID } from 'helpers/IdHelpers';
import { ITeamStandings } from 'types';

// #region CONVERTERS *******************************************************************
export const teamStandingsToDoc = (standings: ITeamStandings): DocumentData => {
  return {
    uID: standings.uID,
    result: standings.result,
    pointsScored: standings.pointsScored,
    pointsAllowed: standings.pointsAllowed,
    isHomeTeam: standings.isHomeTeam,
    isByeWeek: standings.isByeWeek,
    wins: standings.wins,
    losses: standings.losses,
    ties: standings.ties,
    pct: standings.pct,
    pf: standings.pf,
    pa: standings.pa,
    homeRecord: standings.homeRecord,
    awayRecord: standings.awayRecord,
    streak: standings.streak,
    inDivisionHomeRecord: standings.inDivisionHomeRecord,
    inDivisionAwayRecord: standings.inDivisionAwayRecord,
    seasonWeekID: standings.seasonWeekID ?? breakUID(standings.uID).seasonWeekID,
  };
};

export const teamStandingsConverter: FirestoreDataConverter<ITeamStandings> = {
  toFirestore(game: ITeamStandings): DocumentData {
    return teamStandingsToDoc(game);
  },

  fromFirestore(docSnap: QueryDocumentSnapshot, options?: SnapshotOptions): ITeamStandings {
    const standings = docSnap.data(options);

    return {
      uID: standings.uID,
      result: standings.result,
      pointsScored: standings.pointsScored,
      pointsAllowed: standings.pointsAllowed,
      isHomeTeam: standings.isHomeTeam,
      isByeWeek: standings.isByeWeek,
      wins: standings.wins,
      losses: standings.losses,
      ties: standings.ties,
      pct: standings.pct,
      pf: standings.pf,
      pa: standings.pa,
      homeRecord: standings.homeRecord,
      awayRecord: standings.awayRecord,
      streak: standings.streak,
      inDivisionHomeRecord: standings.inDivisionHomeRecord,
      inDivisionAwayRecord: standings.inDivisionAwayRecord,
      seasonWeekID: standings.seasonWeekID ?? breakUID(standings.uID).seasonWeekID,
    };
  },
};
